import { render } from "./ChangeReceiptInfo.vue?vue&type=template&id=b7a0b340"
import script from "./ChangeReceiptInfo.vue?vue&type=script&lang=js"
export * from "./ChangeReceiptInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__